/**
 * Google Analytics (GA4) provider for BuildLogic.
 * Sends events to the shared BuildLogic property so all apps report to one place.
 */

import type { EventProperties, PageViewData } from '../types';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let measurementId: string | null = null;

export function initGa(id: string) {
  if (typeof window === 'undefined' || !id) return;

  measurementId = id;
  window.dataLayer = window.dataLayer || [];
  const gtag = (...args: unknown[]) => window.dataLayer?.push(args);
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', id);

  // Load the gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);
}

export function trackEvent(eventName: string, properties?: EventProperties) {
  if (typeof window === 'undefined' || !window.gtag || !measurementId) return;
  window.gtag('event', eventName, properties ?? {});
}

export function trackPageView(data: PageViewData) {
  if (typeof window === 'undefined' || !window.gtag || !measurementId) return;
  window.gtag('event', 'page_view', {
    page_path: data.path,
    page_title: data.path,
    ...data,
  });
}

export function getGaMeasurementId(): string | null {
  return measurementId;
}
